(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contact-us"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.wiInquiryInstalled) return;
  window.wiInquiryInstalled = true;

  function sync(form) {
    const phone = form.querySelector('[name="contact[phone]"]');
    const phoneLabel = form.querySelector('[data-phone-label]');
    const reply = form.querySelector('[name="contact[Preferred reply]"]:checked');

    if (phone && phoneLabel) {
      phone.required = reply?.value === 'Phone';
      phoneLabel.textContent = phone.required
        ? 'Phone number *'
        : 'Phone number (optional)';
      phone.setCustomValidity(
        phone.required && !phone.value.trim()
          ? 'Please enter your phone number.'
          : ''
      );
    }

    const reasons = Array.from(
      form.querySelectorAll('[data-inquiry-reason]:checked')
    );
    const other = reasons.some(
      input => input.dataset.inquiryReason === 'Other'
    );
    const delivery = reasons.some(
      input => input.dataset.inquiryReason === 'Delivery timing'
    );

    const details = form.querySelector('#wi-details');
    const otherText = form.querySelector('#wi-other');
    if (!details || !otherText) return;

    form.querySelector('[data-details-panel]').hidden = other;
    form.querySelector('[data-other-panel]').hidden = !other;

    details.disabled = other;
    details.required = !other && reasons.length === 0;
    otherText.disabled = !other;
    otherText.required = other;

    form.querySelector('[data-details-label]').textContent =
      details.required
        ? 'How can we help? *'
        : 'Additional details (optional)';

    form.querySelector('[data-delivery-help]').hidden = !delivery;

    for (const text of [details, otherText]) {
      const empty = text.required && !text.disabled && !text.value.trim();
      text.setCustomValidity(
        empty ? 'Please tell us how we can help.' : ''
      );
      text.parentElement.querySelector('[data-text-counter]').textContent =
        text.value.length.toLocaleString() + ' / 1,000 characters';
    }
  }

  for (const eventName of ['change', 'input', 'focusin']) {
    document.addEventListener(eventName, event => {
      const form = event.target.closest('.wi-inquiry-form');
      if (form) sync(form);
    });
  }

  document.addEventListener('submit', event => {
    const form = event.target.closest('.wi-inquiry-form');
    if (!form) return;

    sync(form);

    if (!form.checkValidity()) {
      event.preventDefault();
      form.reportValidity();
    }
  }, true);

  function reopenErrors() {
    const source = document.getElementById('askquestion-popup');
    if (source?.content?.querySelector('.wi-inquiry-errors')) {
      document.querySelector('.open-askquestion-popup')?.click();
    }
  }

  if (document.readyState === 'complete') reopenErrors();
  else window.addEventListener('load', reopenErrors, { once: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["watch-it-offer-placement"] && !Shopify.designMode) return;
  try {
    (() => {
  let attempts = 0;
  const install = () => {
    const host = document.getElementById('app-embed-container-587311');
    const root = host?.shadowRoot;
    const header = document.getElementById('page-header');
    if (!host || !root || !header) return false;
    if (document.getElementById('watch-it-offer-slot')) return true;
    const slot = document.createElement('div');
    slot.id = 'watch-it-offer-slot';
    header.after(slot);
    slot.append(host);
    const style = document.createElement('style');
    style.textContent = `
      [data-form-root="true"][data-current-step="tease"] {
        position: static !important;
        inset: auto !important;
        transform: none !important;
        rotate: none !important;
        width: 100% !important;
        max-width: none !important;
        padding: 0 !important;
        z-index: auto !important;
      }
      #app-embed[data-current-step="tease"] > div {
        rotate: none !important;
        transform: none !important;
      }
      #app-embed[data-current-step="tease"] [data-testid="app-router"] {
        width: 100%;
        max-width: none;
        animation: none;
      }
      #app-embed[data-current-step="tease"] [data-testid="form-teaser"] {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        width: 100%;
        max-width: none;
        min-height: 40px;
        margin: 0 !important;
        padding: 9px 44px;
        border: 0;
        border-bottom: 1px solid #e5e5e5;
        border-radius: 0;
        box-shadow: none;
        background: #f5f5f5;
        color: #202223;
      }
      [data-current-step="tease"] [data-testid="form-teaser"] h3 {
        margin: 0;
        font-size: 13px;
        line-height: 20px;
        font-weight: 600;
      }
      [data-current-step="tease"] [aria-label="Close modal"] {
        position: absolute;
        inset: 50% 12px auto auto;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        padding: 4px;
      }
    `;
    root.append(style);
    let queued = false;
    const follow = () => {
      queued = false;
      const teaser = root.querySelector('[data-current-step="tease"]');
      const nav = document.getElementById('sticky-header');
      const bounds = nav?.getBoundingClientRect();
      const top = bounds && bounds.top <= 1 && bounds.bottom > 0 ? bounds.bottom : 0;
      const stuck = Boolean(teaser && slot.getBoundingClientRect().top < top);
      if (stuck) {
        slot.style.setProperty('--wi-offer-height', `${host.getBoundingClientRect().height}px`);
        slot.style.setProperty('--wi-offer-top', `${top}px`);
      }
      slot.toggleAttribute('data-stuck', stuck);
    };
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(follow);
    };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    const nav = document.getElementById('sticky-header');
    if (nav) {
      new ResizeObserver(schedule).observe(nav);
      nav.addEventListener('transitionend', schedule);
    }
    new MutationObserver(schedule).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-current-step']
    });
    schedule();
    return true;
  };
  if (install()) return;
  const timer = setInterval(() => {
    attempts += 1;
    if (install() || attempts >= 150) clearInterval(timer);
  }, 200);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wi-dispatch-promise"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wi-dispatch-promise')) {
  customElements.define('wi-dispatch-promise', class extends HTMLElement {
    connectedCallback() { queueMicrotask(() => this.initialize()); }
    initialize() {
      if (!this.isConnected || this.initialized) return;
      this.initialized = true;
      this.root = this.closest('.shopify-section');
      this.text = this.querySelector('p');
      this.selected = this.dataset.variantId;
      this.readRecords(this);
      this.change = event => { if(event.target.name === 'id') this.select(event.target.value); };
      this.click = event => {
        if(event.target.closest('.bls__option-swatch,.sticky-addcart-opstion')) requestAnimationFrame(() => {
          const variant = this.root.querySelector('variant-selects')?.currentVariant;
          if(variant) this.select(variant.id);
        });
      };
      this.visible = () => { if(!document.hidden) this.refresh(); };
      this.pop = () => { const id = new URL(location.href).searchParams.get('variant'); if(id) this.select(id); };
      this.root.addEventListener('change',this.change);
      this.root.addEventListener('click',this.click);
      document.addEventListener('visibilitychange',this.visible);
      window.addEventListener('popstate',this.pop);
      this.render();
      this.timer = setInterval(() => { this.render(); if(!document.hidden) this.refresh(); },60000);
    }
    readRecords(element) {
      try { this.records = new Map(JSON.parse(element.querySelector('script').textContent).map(v => [String(v.id),v])); }
      catch { this.records = new Map(); }
    }
    select(id) { this.selected = String(id); this.render(); this.refresh(); }
    render() {
      let state = this.records.get(this.selected)?.state || 'unknown';
      if(state === 'supplier') {
        const record = this.records.get(this.selected), now = Date.now();
        const checked = Date.parse(record.checked_at), expires = Date.parse(record.expires_at);
        if(!Number.isFinite(checked) || !Number.isFinite(expires) || checked > now || now-checked >= 86400000 || expires <= now) state = 'unknown';
      }
      const message = state === 'local' ? this.dataset.local : state === 'supplier' ? this.dataset.supplier : '';
      this.hidden = !message;
      this.text.textContent = message;
      this.root.dataset.wiDispatchKnown = String(Boolean(message));
    }
    async refresh() {
      if(this.pending || !this.isConnected) return;
      this.pending = true;
      const controller = new AbortController(), deadline = setTimeout(() => controller.abort(),10000);
      try {
        const url = new URL(location.href);
        url.searchParams.set('section_id',this.dataset.sectionId);
        url.searchParams.set('variant',this.selected);
        url.searchParams.set('_dispatch_refresh',String(Date.now()));
        const response = await fetch(url,{credentials:'same-origin',cache:'no-store',signal:controller.signal});
        if(!response.ok) throw new Error('Dispatch refresh unavailable');
        const html = new DOMParser().parseFromString(await response.text(),'text/html');
        const element = html.querySelector('wi-dispatch-promise');
        if(element) this.readRecords(element); else this.records = new Map();
      } catch { this.records = new Map(); }
      finally { clearTimeout(deadline); this.pending = false; this.render(); }
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.root?.removeEventListener('change',this.change);
      this.root?.removeEventListener('click',this.click);
      document.removeEventListener('visibilitychange',this.visible);
      window.removeEventListener('popstate',this.pop);
      this.initialized = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
